import { SectionHeading } from "@/components/redesign/SectionHeading";
import type { SectionHeadingBlockProps } from "@/puck/types";

export function SectionHeadingBlock({
  eyebrow,
  title,
  subtitle,
  align = "left",
}: Readonly<SectionHeadingBlockProps>) {
  return (
    <SectionHeading
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
      align={align}
    />
  );
}
